import { __assign } from "tslib";
import { ItemType } from '../domain';
export * from './custom-field-type.enum';
export * from './testkit';
export * from './dto';
export * from './custom-fields-configuration-data';
export * from './multilevel-custom-field.builder';
export * from './multilevel-custom-field-value.builder';
export var createSimpleCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = "".concat(baseUrl, "/fields");
    return {
        getCustomFields: function () { return http.get("".concat(url)); },
        getCustomField: function (id) { return http.get("".concat(url, "/").concat(id)); },
        adminGetCustomField: function (id) { return http.get("".concat(url, "/").concat(id, "/admin")); },
        adminGetCustomFields: function () { return http.get("".concat(url, "/admin")); },
        addCustomField: function (dto) { return http.post("".concat(url), __assign(__assign({}, dto), { itemType: itemType })); },
        updateCustomField: function (dto) { return http.put("".concat(url, "/").concat(dto.id), dto); },
        deleteCustomField: function (id) { return http.delete("".concat(url, "/").concat(id)); },
    };
};
export var createMultiLingualCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = "".concat(baseUrl, "/fields");
    return {
        getCustomFields: function () { return http.get("".concat(url)); },
        getCustomField: function (id) { return http.get("".concat(url, "/").concat(id)); },
        adminGetCustomField: function (id) { return http.get("".concat(url, "/").concat(id, "/admin")); },
        adminGetCustomFields: function () { return http.get("".concat(url, "/admin")); },
        addCustomField: function (dto) { return http.post("".concat(url), __assign(__assign({}, dto), { itemType: itemType })); },
        updateCustomField: function (dto) { return http.put("".concat(url, "/").concat(dto.id), dto); },
        deleteCustomField: function (id) { return http.delete("".concat(url, "/").concat(id)); },
    };
};
export var createMultilevelCustomFieldsApi = function (baseUrl, http, itemType) {
    var url = "".concat(baseUrl, "/fields/multiLevel");
    return {
        addMultilevelCustomField: function (dto) { return http.post("".concat(url), __assign(__assign({}, dto), { itemType: itemType })); },
        updateMultilevelCustomField: function (dto) { return http.put("".concat(url, "/").concat(dto.id), dto); },
    };
};
export var createCustomFieldsApi = function (baseUrl, http) {
    var ticketsUrl = "".concat(baseUrl, "/tickets");
    var usersUrl = "".concat(baseUrl, "/users");
    var companiesUrl = "".concat(baseUrl, "/companies");
    return {
        users: createSimpleCustomFieldsApi(usersUrl, http, ItemType.USER),
        companies: createSimpleCustomFieldsApi(companiesUrl, http, ItemType.COMPANY),
        tickets: createMultiLingualCustomFieldsApi(ticketsUrl, http, ItemType.TICKET),
        multilevel: createMultilevelCustomFieldsApi(ticketsUrl, http, ItemType.TICKET),
    };
};
//# sourceMappingURL=index.js.map